import { Chain } from "viem/chains";
import { readContract } from "wagmi/actions";
import { BALANCES_ALLOWANCES_CONTRACT_ABI } from "../../config/abis/BalancesAllowancesContract.abi";
import { Amount } from "../../types/amount";
import { Token } from "./TokenEnum";
import { Balance } from "./getBalances";
import { TokenList } from "./getAllTokenLists";
import { cloneDeep } from "lodash-es";
import { getTokenDecimals } from "../../utils/tokenUtils";
import { BALANCE_CONTRACTS } from "config/consts";

export type Balances = Array<Balance>;

const NATIVE_TOKEN_ADDRESS: `0x${string}` = "0x0000000000000000000000000000000000000000";
export const fetchBalancesFast = async (
  userAddress: string,
  tokens: TokenList,
  network: Chain
): Promise<Balances> => {
  if (network && tokens) {
    const tokenSymbols = [...(Object.keys(tokens) as Array<Token>)];
    const tokensAddresses = tokenSymbols.map(symbol => {
      if (symbol === network.nativeCurrency.symbol) {
        return NATIVE_TOKEN_ADDRESS;
      }
      const contractAddress = tokens[symbol]?.chainInfo.contractAddress;
      return contractAddress;
    }) as Array<`0x${string}`>;
    return readContract({
      address: BALANCE_CONTRACTS[network.id],
      abi: BALANCES_ALLOWANCES_CONTRACT_ABI,
      functionName: "walletBalances",
      args: [userAddress as `0x${string}`, tokensAddresses],
    })
      .then(res => {
        const balances = res.map((balanceBigInt, index) => {
          const tokenDecimals = getTokenDecimals(tokenSymbols[index], cloneDeep(tokens));
          const divisor = new Amount((10 ** tokenDecimals).toString());
          const balance = new Amount(balanceBigInt.toString()).div(divisor);
          return { symbol: tokenSymbols[index], balance: balance };
        });
        return balances;
      })
      .catch(err => {
        console.error(`Balances error error`, err);
        return [];
      });
  }
  return [];
};
